module.exports = __webpack_public_path__ + "static/agami_-7608055f99091686fef9b5e2f747af6b.png";